import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const BUYERS = [{
  name: 'Martín L.',
  city: 'Buenos Aires'
}, {
  name: 'Carlos R.',
  city: 'Córdoba'
}, {
  name: 'Diego F.',
  city: 'Rosario'
}, {
  name: 'Facundo M.',
  city: 'Mendoza'
}, {
  name: 'Nicolás P.',
  city: 'Tucumán'
}, {
  name: 'Sebastián G.',
  city: 'Mar del Plata'
}, {
  name: 'Alejandro T.',
  city: 'Salta'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyerIndex, setCurrentBuyerIndex] = useState(0);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    // Interval to cycle through buyers
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentBuyerIndex(prev => (prev + 1) % BUYERS.length);
        setIsVisible(true);
      }, 500); // Wait for exit animation before showing next
    }, 8000); // Show a new one every 8 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const buyer = BUYERS[currentBuyerIndex];
  return <div className={`
        fixed bottom-4 left-4 z-50 bg-[#0f1d32] rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.5)] border border-blue-900/40 p-3 flex items-center gap-3 max-w-xs
        transition-all duration-500 ease-in-out
        ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}
      `} data-id="element-177">
      <div className="bg-green-500/20 p-2 rounded-full flex-shrink-0 border border-green-500/30" data-id="element-178">
        <CheckCircle2 className="w-6 h-6 text-green-400" data-id="element-179" />
      </div>
      <div data-id="element-180">
        <p className="text-sm text-gray-200 font-medium leading-tight mb-0.5" data-id="element-181">
          <span className="font-bold text-white" data-id="element-182">{buyer.name}</span> de{' '}
          {buyer.city}
        </p>
        <p className="text-xs text-blue-300/80" data-id="element-183">acaba de acceder al sistema</p>
      </div>
    </div>;
}